import {dispatch as d3dispatch} from 'd3-dispatch';

var dispatch = d3dispatch(
	'mapBoundariesReady',
	'dataReady',
	'selectedSeriesUpdate',
	'highlightedCountryUpdate',
	'hoveredCountryUpdate',
	'mapMousemove',
	'includeIndirectDeathsUpdate',
	'includeStuntingUpdate',
	'dalysByRateUpdate'
);

var api = {
	dispatch: dispatch
};

export default api;




/** WEBPACK FOOTER **
 ** ./src/Dispatch/Dispatch.js
 **/